// src/pages/RoomAvailability.js
import React, { useState, useEffect } from "react";
import config from "../../config";
import {
  Card,
  CardContent,
  CardHeader,
  TextField,
  MenuItem,
  Grid,
  CircularProgress,
} from "@mui/material";
import axios from "axios";

export default function RoomAvailability() {
  const [hotels, setHotels] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [selectedHotel, setSelectedHotel] = useState("");
  const [selectedRoom, setSelectedRoom] = useState("");
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0] // today by default (yyyy-MM-dd)
  );
  const [loadingHotels, setLoadingHotels] = useState(false);
  const [loadingRooms, setLoadingRooms] = useState(false);
  const [roomStatus, setRoomStatus] = useState([]);
  const [loadingStatus, setLoadingStatus] = useState(false);
  const url = `${config.API_BASE_URL}${config.PRODUCT_LIST_API}`;
  // Fetch hotels on page load
  useEffect(() => {
    const fetchHotels = async () => {
      setLoadingHotels(true);
      const token = sessionStorage.getItem("token");
      try {
        const res = await axios.get(
          `${config.API_BASE_URL}/Home/GetHotelsdropdown`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        console.log("Hotels data:", res.data);
        setHotels(res.data || []);
      } catch (err) {
        console.error("Error fetching hotels:", err);
        setHotels([]);
      }
      setLoadingHotels(false);
    };
    fetchHotels();
  }, []);

  // Fetch rooms when hotel changes
  useEffect(() => {
    if (!selectedHotel) return;
    const fetchRooms = async () => {
      setLoadingRooms(true);
      const token = sessionStorage.getItem("token");
      try {
        const res = await axios.get(
          `${config.API_BASE_URL}/Home/GetAllRoomDropdown/${selectedHotel}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        console.log("Rooms data:", res.data);
        setRooms(res.data || []);
      } catch (err) {
        console.error("Error fetching rooms:", err);
        setRooms([]);
      }
      setLoadingRooms(false);
    };
    fetchRooms();
  }, [selectedHotel]);

  // Fetch room availability whenever hotel, room, or date changes
  useEffect(() => {
    if (!selectedHotel || !selectedRoom || !selectedDate) return;

    const fetchRoomStatus = async () => {
      setLoadingStatus(true);
      const token = sessionStorage.getItem("token");
      try {
        const res = await axios.get(
          `${config.API_BASE_URL}/Home/GetRoomAvailability/${selectedHotel}/${selectedRoom}?date=${selectedDate}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        console.log("Room availability data:", res.data);

        const { totalRooms = 0, bookedRooms = 0 } = res.data || {};
        const statusArray = [];
        for (let i = 1; i <= totalRooms; i++) {
          statusArray.push(i <= bookedRooms ? "booked" : "available");
        }
        setRoomStatus(statusArray);
      } catch (err) {
        console.error("Error fetching room status:", err);
        setRoomStatus([]);
      }
      setLoadingStatus(false);
    };
    fetchRoomStatus();
  }, [selectedHotel, selectedRoom, selectedDate]);

  const handleHotelChange = (e) => {
    setSelectedHotel(e.target.value);
    setSelectedRoom("");
    setRooms([]);
    setRoomStatus([]);
  };

  return (
    <div style={{ padding: 20 }}>
      {/* Hotel Dropdown */}
      <Card style={{ marginBottom: 20 }}>
        <CardHeader title="Select Hotel" />
        <CardContent>
          <TextField
            select
            label="Select Hotel"
            fullWidth
            value={selectedHotel}
            onChange={handleHotelChange}
            disabled={loadingHotels}
          >
            {hotels.map((h, index) => (
              <MenuItem key={h.ID || h.id || index} value={h.ID || h.id}>
                {h.HotelName || h.hotelName || h.Name || "Unnamed Hotel"}
              </MenuItem>
            ))}
          </TextField>
        </CardContent>
      </Card>

      {/* Room Dropdown */}
      <Card style={{ marginBottom: 20 }}>
        <CardHeader title="Select Room" />
        <CardContent>
          <TextField
            select
            label="Select Room"
            fullWidth
            value={selectedRoom}
            onChange={(e) => setSelectedRoom(e.target.value)}
            disabled={!rooms.length || loadingRooms}
          >
            {rooms.map((r, index) => (
              <MenuItem key={r.ID || r.id || index} value={r.ID || r.id}>
                {r.Type || r.type || r.Name || "Unnamed Room"}
              </MenuItem>
            ))}
          </TextField>
        </CardContent>
      </Card>

      {/* Date Picker */}
      <Card style={{ marginBottom: 20 }}>
        <CardHeader title="Select Date" />
        <CardContent>
          <TextField
            type="date"
            fullWidth
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
        </CardContent>
      </Card>

      {/* Room Availability */}
      {loadingStatus ? (
        <CircularProgress />
      ) : (
        <Grid container spacing={2}>
          {roomStatus.map((status, index) => (
            <Grid item key={index}>
              <div
                style={{
                  width: 50,
                  height: 50,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: status === "available" ? "green" : "red",
                  color: "white",
                  borderRadius: 4,
                  fontWeight: "bold",
                }}
              >
                {index + 1}
              </div>
            </Grid>
          ))}
        </Grid>
      )}
    </div>
  );
}
